import React, { useRef, useState } from 'react';
import { ArrowIcon } from './ArrowIcon';
import './Footer.scss';

const SCRAMBLE_CHARS = '!<>-_\\/[]{}–=+*^?#';
const TARGET = "Let's get coffee";

const socials = [
  { label: 'LinkedIn', href: 'https://www.linkedin.com/in/ryanchongzx/' },
  { label: 'Medium', href: 'https://ryanchongzx.medium.com/' },
  { label: 'Instagram', href: 'https://www.instagram.com/ryanchongzx/' },
];

const Footer: React.FC = () => {
  const [display, setDisplay] = useState(TARGET);
  const timer = useRef<ReturnType<typeof setInterval> | null>(null);

  const startScramble = () => {
    if (timer.current) return;
    let iteration = 0;
    timer.current = setInterval(() => {
      setDisplay(
        TARGET.split('')
          .map((ch, i) => {
            if (ch === ' ' || ch === "'") return ch;
            if (i < iteration) return TARGET[i];
            return SCRAMBLE_CHARS[Math.floor(Math.random() * SCRAMBLE_CHARS.length)];
          })
          .join('')
      );
      iteration += 1;
      if (iteration > TARGET.length) {
        if (timer.current) clearInterval(timer.current);
        timer.current = null;
        setDisplay(TARGET);
      }
    }, 28);
  };

  return (
    <footer id="contact" className="contact">
      <div className="contact__inner section-inner">
        <div className="contact__top">
          <div className="contact__portrait">
            <img
              src="/images/ry-profile.jpg"
              alt="Ryan Chong"
              className="contact__portrait-img"
              loading="lazy"
            />
          </div>

          <div className="contact__text">
            <h2 className="contact__label">Contact</h2>
            <a
              href="https://www.linkedin.com/in/ryanchongzx/"
              target="_blank"
              rel="noopener noreferrer"
              className="contact__headline"
              onMouseEnter={startScramble}
              data-cursor-hover
            >
              <span className="contact__headline-text">{display}</span>
              <ArrowIcon className="contact__headline-arrow" />
            </a>
          </div>
        </div>

        <p className="contact__note">
          I'm always happy to share experiences with founders and work with them towards
          product-market fit. Deeply passionate about coffee, music, and design – drop me a line
          if you'd like to chat.
        </p>

        <div className="contact__bar">
          <div className="contact__copyright">
            © {new Date().getFullYear()} Ryan Chong. Based in Singapore.
          </div>
          <div className="contact__socials">
            {socials.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                className="contact__social"
                data-cursor-hover
              >
                {s.label}
                <span className="contact__social-underline" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
